import { RequestTicket, ResponseDataError } from 'src/types'

export enum ReceiptsActionTypes {
  REMOVE_RECEIPT = '@receipts/REMOVE_RECEIPT',
  REMOVE_RECEIPT_FAILURE = '@receipts/REMOVE_RECEIPT_FAILURE',
  REMOVE_RECEIPT_SUCCESS = '@receipts/REMOVE_RECEIPT_SUCCESS',
  SAVE_RECEIPT = '@receipts/SAVE_RECEIPT',
  SAVE_RECEIPT_FAILURE = '@receipts/SAVE_RECEIPT_FAILURE',
  SAVE_RECEIPT_SUCCESS = '@receipts/SAVE_RECEIPT_SUCCESS',
  SET_SAVED_RECEIPT = '@receipts/SET_SAVED_RECEIPT'
}

export type ResponseDataTickets = ResponseDataError & {
  request_tickets: RequestTicket[]
}

export interface ReceiptsState {
  readonly policyViolated: boolean
  readonly removeReceiptError: ''
  readonly removeReceiptLoading: boolean
  readonly savedReceipt: RequestTicket
  readonly saveReceiptError: ''
  readonly saveReceiptLoading: boolean
}
